"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.graphqlOperation = exports.AmplifyAPI = exports.Amplify = exports.onBeforeStart = exports.start = exports.cognito = exports.vid = exports.API = exports.mutations = exports.queries = exports.AmazonCognitoIdentity = void 0;
var vid = __importStar(require("./vid"));
var cognito = __importStar(require("./cognito"));
exports.AmazonCognitoIdentity = __importStar(require("amazon-cognito-identity-js"));
exports.queries = __importStar(require("./graphql/queries"));
exports.mutations = __importStar(require("./graphql/mutations"));
exports.API = __importStar(require("./API"));
var aws_exports_1 = __importDefault(require("./aws-exports"));
exports.vid = __importStar(require("./vid"));
exports.cognito = __importStar(require("./cognito"));
var core_1 = __importDefault(require("@aws-amplify/core"));
exports.Amplify = core_1.default;
var _onBeforeStartFunctions = [];
var startPromise = null;
// Browser entry point
function start(browser) {
    var _this = this;
    if (browser === void 0) { browser = true; }
    if (startPromise == null) {
        startPromise = new Promise(function (resolve) { return __awaiter(_this, void 0, void 0, function () {
            var _onBeforeStartFunctions_1, _onBeforeStartFunctions_1_1, fn, e_1_1;
            var e_1, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        core_1.default.configure(aws_exports_1.default);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 7, 8, 13]);
                        _onBeforeStartFunctions_1 = __asyncValues(_onBeforeStartFunctions);
                        _b.label = 2;
                    case 2: return [4 /*yield*/, _onBeforeStartFunctions_1.next()];
                    case 3:
                        if (!(_onBeforeStartFunctions_1_1 = _b.sent(), !_onBeforeStartFunctions_1_1.done)) return [3 /*break*/, 6];
                        fn = _onBeforeStartFunctions_1_1.value;
                        return [4 /*yield*/, fn()];
                    case 4:
                        _b.sent();
                        _b.label = 5;
                    case 5: return [3 /*break*/, 2];
                    case 6: return [3 /*break*/, 13];
                    case 7:
                        e_1_1 = _b.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 13];
                    case 8:
                        _b.trys.push([8, , 11, 12]);
                        if (!(_onBeforeStartFunctions_1_1 && !_onBeforeStartFunctions_1_1.done && (_a = _onBeforeStartFunctions_1.return))) return [3 /*break*/, 10];
                        return [4 /*yield*/, _a.call(_onBeforeStartFunctions_1)];
                    case 9:
                        _b.sent();
                        _b.label = 10;
                    case 10: return [3 /*break*/, 12];
                    case 11:
                        if (e_1) throw e_1.error;
                        return [7 /*endfinally*/];
                    case 12: return [7 /*endfinally*/];
                    case 13:
                        if (!browser) return [3 /*break*/, 16];
                        return [4 /*yield*/, vid.start()];
                    case 14:
                        _b.sent();
                        return [4 /*yield*/, cognito.start()];
                    case 15:
                        _b.sent();
                        _b.label = 16;
                    case 16:
                        resolve();
                        return [2 /*return*/];
                }
            });
        }); });
    }
    return startPromise;
}
exports.start = start;
function onBeforeStart(fn) {
    _onBeforeStartFunctions.push(fn);
}
exports.onBeforeStart = onBeforeStart;
var api_1 = require("@aws-amplify/api");
Object.defineProperty(exports, "AmplifyAPI", { enumerable: true, get: function () { return __importDefault(api_1).default; } });
Object.defineProperty(exports, "graphqlOperation", { enumerable: true, get: function () { return api_1.graphqlOperation; } });
//# sourceMappingURL=main.js.map